<template>
  <!-- Blog Area -->
  <div class="blog-area bg-white section-padding-xs">
    <div class="container">
      <div class="blog-items-wrapper">

        <!-- Blog Item -->
        <article class="blog-item" v-for="item in list">
          <div class="row">
            <div class="col-lg-5 col-12">
              <div class="blog-item-thumb">
                <router-link :to="{ name: 'subject-detail', params: { id:item.id}}">
                  <img :src="item.pic" :alt="item.title">
                </router-link>
              </div>
            </div>
            <div class="col-lg-7 col-12">
              <div class="blog-item-content">
                <h4 class="blog-item-title"><router-link :to="{ name: 'subject-detail', params: { id:item.id}}">{{item.title}}</router-link></h4>
                <div class="blog-item-meta"><i class="fa fa-clock-o"></i>{{_formatDate(item.createTime)}} / POSTED BY <b>BUKIBAGS.COM</b></div>
                <p>{{item.description}}</p>
                <!--<a :href="'/blog/subject/info-'+item.id" class="sn-readmore">-->
                <router-link :to="{ name: 'subject-detail', params: { id:item.id}}" class="sn-readmore">
                  Read More
                  <i class="fa fa-arrow-right"></i>
                </router-link>
              </div>
            </div>
          </div>
        </article>
        <!--// Blog Item -->
      </div>
    </div>
  </div>
</template>

<script>

  import request from '@/utils/request'
  import {formatDate} from '@/utils/date'
    export default {
        name: "subject-index",
        data(){
          return {
            list:[]
          }
        },
        methods:{
          _formatDate(date){

            return formatDate(new Date(date),'yyyy-MM-dd')
          }
        },
        created(){
          let _this = this
          let reg = new RegExp("large-size","g");

          request({
            url:"/subject/list?categoryId=1",
            method:"GET"
          }).then(res=>{
            if(res.data.code===200)
              _this.list = res.data.data
             _this.list.forEach((item,index)=>{
              item.pic =item.pic.replace(reg,'thumbnail-size')
            })
          })
        }
    }
</script>

<style scoped>

</style>
